<template>
    <b-card no-body>
        <b-card-header class="border-0">
            <b-row></b-row>
        </b-card-header>
        <b-col cols="12">
            <b-row class="d-flex align-items-center justify-content-md-between">
                <b-col cols="12" md="6" class="d-md-flex">
                    <base-input
                        label="Search"
                        v-model="params.search.inv_user_name"
                        v-on:input="debouncedHandler"
                        prepend-icon="fas fa-search"
                        placeholder="Search Customer"
                    >
                    </base-input>
                    <base-input label="Filter by Status" class="mx-4">
                        <el-select
                            v-model="params.search.inv_status"
                            placeholder="Select Status"
                            @change="filterByStatus()"
                            >
                            <el-option value="">
                                All
                            </el-option>
                            <el-option
                                v-for="item in statusList"
                                :key="item.value"
                                :label="item.status"
                                :value="item.status"
                            >
                            </el-option>
                        </el-select>
                    </base-input>
                </b-col>
                <b-col cols="12" md="3" >
                    <b-button class="float-right px-3 py-2 mb-2 mb-md-0" variant="outline-secondary" @click="$refs.drawer_filter_proforma_invoice.viewFilterInvoice()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="#73839C" d="M9 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM6.17 5a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-7.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 0 1 0-2h1.17zM15 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2.83 0a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-1.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 1 1 0-2h7.17zM9 17a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2.83 0a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-7.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 1 1 0-2h1.17z"/></svg>
                        Filters
                    </b-button>
                </b-col>
            </b-row>
        </b-col>
        <div class="table-listings">
            <el-table 
                ref="multipleTable"
                :data="tableData"
                style="width: 100%"
                @selection-change="selectionChange"
            >
                <el-table-column
                    type="selection"
                    width="55"
                ></el-table-column>

                <el-table-column
                    prop="invoice_no"
                    label="Invoice No."
                    min-width="130"
                    width="auto"
                >
                    <template slot-scope="scope">
                        <div>
                            <p class="font-weight-500 text-primary">{{ scope.row.inv_id }}</p>
                        </div>
                    </template>
            
                </el-table-column>

                <el-table-column
                    label="Customer Name"
                    min-width="170"
                    width="auto"
                    prop="inv_user_name"
                >
                    <template slot-scope="scope">
                        <div>
                            <!-- <p class="mb-0 top-line">{{ scope.row.inv_user_name }}</p> -->
                            <p class="top-line text-break">{{ scope.row.inv_user_name }}</p>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="status"
                    label="Status"
                    min-width="150"
                    width="auto"
                >
                    <template slot-scope="scope">
                        <el-dropdown trigger="click" v-model="invoiceStatus">
                            <p class="el-dropdown-link top-line">
                                <span v-if="scope.row.inv_status" class="d-inline-block text-truncate" :class="generateStatusColor(scope.row.inv_status)" style="max-width: 150px; overflow: unset;">{{ scope.row.inv_status | shortenText(20) }}</span>
                                <span v-else>-</span>
                                <i class="el-icon-caret-bottom el-icon--right"></i>
                            </p>
                            <el-dropdown-menu slot="dropdown">
                                <div style="max-height: 300px;overflow-y: auto;">
                                    <el-dropdown-item v-for="status in statusList" :key="status.id"  @click.native="updateInvoiceStatus(scope.row,status.status)">{{ status.status }}</el-dropdown-item>
                                </div>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="total_amount"
                    label="Total Amount"
                    min-width="150"
                    width="auto"
                >
                    <template slot-scope="scope">
                        <p class="mb-0 top-line">RM {{ scope.row.inv_total_payment| moneyFormatter }}</p>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="created_date"
                    label="Created Date"
                    min-width="150"
                    width="auto"
                >
                    <template slot-scope="scope">
                        <p class="mb-0 top-line">{{scope.row.inv_created_date | dateFormatString }}</p>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="invoice_date"
                    label="Invoice Date"
                    min-width="150"
                    width="auto"
                >
                    <template slot-scope="scope">
                        <p class="mb-0 top-line">{{scope.row.inv_issued_date | dateFormatString }}</p>
                    </template>
                
                </el-table-column>

                <el-table-column
                    prop="edit"
                    min-width="100"
                    width="auto"
                >
                    <template slot-scope="scope">
                        <p class="mb-0 top-line text-primary" style="cursor: pointer;" @click="$refs.drawer_proforma_invoice_form.show(scope.row)">Edit</p>
                    </template>
                </el-table-column>

                <el-table-column
                    fixed="right"
                >
                    <template slot-scope="scope">
                        <el-dropdown trigger="click"  style="cursor: pointer">
                            <p class="el-dropdown-link mb-0 top-line">
                                <b-icon icon="three-dots-vertical"></b-icon>
                            </p>
                            <el-dropdown-menu slot="dropdown">
                                <!-- <el-dropdown-item>View Change Log</el-dropdown-item> -->
                                <el-dropdown-item class="text-danger" @click.native="deleteInvoice(scope.row)">Delete</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>


            </el-table>
        </div>
        <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-md-between flex-wrap"
        >
            <div class="d-flex align-items-center mb-3">
                <p class="card-category mb-0 text-secondary">
                    Showing {{ pagination.from }} to {{ pagination.to }} of {{ pagination.total }} entries
        
                    <span v-if="selectedRows.length">
                        &nbsp; &nbsp; {{selectedRows.length}} rows selected
                    </span>
                </p>

                <span class="mb-0 ml-4">Rows:</span>

                <el-select
                    class="select-primary pagination-select mx-2"
                    v-model="pagination.perPage"
                    placeholder="Per page"
                    @change="perPageChanged($event)"
                >
                    <el-option
                        class="select-primary"
                        v-for="item in pagination.perPageOptions"
                        :key="item"
                        :label="item"
                        :value="item"
                    >
                    </el-option>
                </el-select>
    
                <DrawerFilterInvoice ref="drawer_filter_proforma_invoice" @filter-invoice="filterInvoice"/>
                <DrawerInvoiceForm ref="drawer_proforma_invoice_form" @close=getInvoices />

            </div>
            <base-pagination
                class="pagination-no-border"
                :current="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="pagination.total"
                @change="paginationChanged($event)"
            >
            </base-pagination>

        </div>
    </b-card>
</template>
<script>
import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Tooltip, Select, Option, Button, Badge, Tag, InputNumber } from 'element-ui'
import { BasePagination } from '@/components'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
import {
    notifyFunctionMixin,
    axios,
    services,
    getHeader,
    debounce
} from '@/assets/js/httpImports.js'
import helperFunctionMixin from '@/assets/js/helperFunctionMixin'
import DrawerFilterInvoice from '@/views/Sales/Invoices/OffCanvasInvoices/FilterInvoice'
import DrawerInvoiceForm from '@/views/Sales/Invoices/OffCanvasInvoices/InvoiceForm'
import { EventBus } from "@/main";

export default {
    mixins: [notifyFunctionMixin,clientPaginationMixin],
    components: {
        BasePagination,
        DrawerFilterInvoice,
        DrawerInvoiceForm,
        [Select.name]: Select,
        [Option.name]: Option,
        [Tooltip.name]: Tooltip,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Dropdown.name]: Dropdown,
        [DropdownItem.name]: DropdownItem,
        [DropdownMenu.name]: DropdownMenu,
        [Button.name]: Button,
        [Badge.name]: Badge,
        [Tag.name]: Tag,
        [InputNumber.name]: InputNumber,
    },
    data() {
        return {
            searchText: '',
            isTableLoading: false,
            propsToSearch:['inv_user_name'],
            isFixed: true,
            currentPage: 1,
            mode: 'listing',
            selectedRows: [],
            debouncedHandler: '',
            TableColumn:[{
                type: 'selection'
            }],
            tableData: [],
            statusList: [
                {
                    id:1,
                    status: 'DRAFT',
                },
                {
                    id:2,
                    status: 'ISSUED',
                },
                {
                    id:3,
                    status: 'PAID',
                },
                {
                    id:4,
                    status: 'CANCELED',
                },
            ],
            invoiceStatus: '',
            pagination:{
                perPageOptions: [5, 10, 25, 50, 100, 500],
                from: 1,
                to: 0
            },
            params: {
                pagination: {
                    page:0,
                    limit: 25,
                    order: {
                        inv_id: "DESC"
                    }
                },
                search: {
                    inv_type: "NORMAL",
                    inv_user_name: "",
                    inv_code:"",
                    inv_title:"",
                    inv_description:"",
                    inv_for_payment:"",
                    inv_status:"",
                    inv_application_code:_gAuth.appCode(),
                    inv_created_by:"",
                    inv_updated_by:"",
                    inv_created_date_from: "",
                    inv_created_date_end: "",
                    inv_total_payment_min: "",
                    inv_total_payment_max: "",
                },
                search_input: ''
            },
            customerList: [],
        }
    },
    created(){
        this.pagination.perPage = 25
        this.getInvoices()
    },
    mounted(){
        this.debouncedHandler = debounce(() => {
            this.params.pagination.page = 0
            this.getInvoices()
        }, 500);
    },
		beforeMount() {
			EventBus.$on('refresh-invoice-list', () => {
					this.getInvoices()
			});
		},
		beforeUnmount() {
			EventBus.$off('refresh-invoice-list', () => {
					this.getInvoices()
			});
		},
    methods: {
        selectionChange(selectedRows) {
            this.selectedRows = selectedRows
        },
        paginationChanged(page) {
            this.params.pagination.page = page - 1
            this.pagination.page = page
            this.getInvoices()
        },
        perPageChanged(data) {
            this.params.pagination.limit = data
            this.params.pagination.page = 0
            this.getInvoices()
        },
        async getInvoices(){
            // this.isTableLoading = true
            try{
							let urlSearchParams = _gHlp.generateQueryParams(this.params)
							const res = await axios.get(services.billing+'invoices?'+urlSearchParams, {headers:getHeader()})
                // this.isTableLoading = false
                this.tableData = res.data.content
                this.pagination.total = res.data.pagination.total_data
                this.pagination.currentPage = res.data.current_page
                this.pagination.from = res.data.pagination.page * res.data.pagination.limit + 1
                this.pagination.to = Math.min((Number(res.data.pagination.page) + 1) * res.data.pagination.limit, res.data.pagination.total_data);
            }catch(e){
                this.products = []
                console.log('Product Store (getCustomerProducts) failed:' + e)
            }
        },
        deleteInvoice(invoice) {
            axios.post(services.billing + 'invoice/delete/' + invoice.inv_id, {}, { headers: getHeader() })
            .then(res => {
                console.log(res.data)
                this.notifySuccess('<b>Invoice Successfully Deleted.')
                EventBus.$emit('refresh-invoice-list')
            })
            .catch(e => {
                this.errorFunction(e)
            })
        },
        updateInvoiceStatus(inv, status) {
            inv.inv_status = status
            axios.post(services.billing + 'invoice/' + inv.inv_id, inv, { headers: getHeader() })
            .then(res => {
                this.notifySuccess('<b>Invoice Status : Successfully Updated.')
                this.getInvoices()
            })
            .catch(e => {
                this.errorFunction(e)
            })
        },
        filterByStatus() {
            this.params.pagination.page = 0
            this.getInvoices()
        },
        filterInvoice(date_created, total_amt) {
            if(date_created != "") {
                const arr = date_created.split(',')
                this.params.search.inv_created_date_from = arr[0]
                this.params.search.inv_created_date_end = arr[1]
            }else{
                this.params.search.inv_created_date_from = ""
                this.params.search.inv_created_date_end = ""
            }   
            if(total_amt != "") {
                const arrAmt = total_amt.split(',')
                this.params.search.inv_total_payment_min = arrAmt[0]
                this.params.search.inv_total_payment_max = arrAmt[1]
            }else{
                this.params.search.inv_total_payment_min = ""
                this.params.search.inv_total_payment_max = ""
            }   
            this.getInvoices()
        },
        generateStatusColor(status) {
            switch (status) {
                case 'DRAFT':
                    return 'text-primary'
                case 'ISSUED':
                    return 'text-warning'
                case 'PAID':
                    return 'text-success'
                case 'CANCELED':
                    return 'text-danger'
                default:
                    break;
            }
        }
    }
}
</script>